import {
  UntypedFormArray,
  UntypedFormGroup,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';

export function countriesOfOfferSubscriptionRequiredValidator(
  subStartKey: string,
  subEndKey: string
): ValidatorFn {
  return (control: UntypedFormArray): ValidationErrors | null => {
    control.controls.forEach((subControl: UntypedFormGroup) => {
      const subStartControl = subControl.get(subStartKey);
      const subEndControl = subControl.get(subEndKey);

      if (subStartControl && !subStartControl.value) {
        subStartControl.setErrors({
          required: true,
          message: 'Subscription Start Date is required',
        });
      }

      if (subEndControl && !subEndControl.value) {
        subEndControl.setErrors({
          required: true,
          message: 'Subscription End Date is required',
        });
      }
    });

    return null;
  };
}
